(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pawniko-cookie-choices"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pawniko-cookie-choices]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-pawniko-cookie-status]');
    button.disabled = true;
    status.hidden = true;
    try {
      if (!window.privacyBanner?.showPreferences) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      await window.privacyBanner.showPreferences();
      
    } catch {
      status.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
